<template>
  <div class="intro-dark d-flex flex-column drawer-container">
    <v-list-item
      v-if="$vuetify.breakpoint.mdAndDown"
      class="photo-header"
    > 
        <v-list-item-content>
          <v-img
            src="img/logo/beige_logo.png"
            contain
          >
          </v-img>
        </v-list-item-content>
      </v-list-item>

    <v-list class="pt-0 flex-list" style="">
      <template v-for="item in navigationItems">
        <v-list-item
          :id="'nav-item-' + item.title"
          v-if="item.show"
          :key="item.title"
          @click="(item.action) ? action(item.action) : clickHandler(item.clickEvent)">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <mrx-translation :token="item.title"></mrx-translation>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider v-if="item.show" :key="item.title + '.divider'"></v-divider>
      </template>

      <template v-for="group in navigationGroups">
        <v-list-group
          :id="'nav-group-' + group.title"
          v-model="group.active"
          :key="group.title"
          no-action
          @click="testModeClick()"
          v-if="group.show"
          active-class="drawerOpen"
        >
          <template slot="activator">
            <v-list-item-icon>
              <v-icon class="ma-0">{{ group.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">
                <mrx-translation :token="group.title"></mrx-translation>
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="subItem in group.items"
            :key="subItem.title"
            @click="action(subItem.click)"
            :id="'nav-group-item-' + subItem.title"
            >
            <template v-if="subItem.action">
              <v-list-item-content>
                <v-list-item-title class="text-wrap">
                  <mrx-translation 
                    :showUntranslatedToken="true" 
                    :token="subItem.title"
                    ></mrx-translation>
                  </v-list-item-title>
                </v-list-item-content>
              </template>

            <template v-else>
              <v-list-item-avatar v-if="subItem.select">
                <v-switch color="white" disabled v-model="subItem.value" :label="subItem.title"></v-switch>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-wrap">
                  <mrx-translation 
                    :showUntranslatedToken="true"
                    :token="subItem.title"
                    ></mrx-translation>
                </v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </v-list-group>
        
        <v-divider v-if="group.show" :key="group.title + '.div'"></v-divider>
      </template>
    </v-list>
    <v-container v-if="getMode('show')" class="pa-5 logout-section">
      <v-btn id="logout" block @click="action({ action: 'logout' })">
        <v-icon>{{ icons.mdiLogout }}</v-icon>
        <mrx-translation token="app.nav.menu.account.logout.title"></mrx-translation>
      </v-btn>
    </v-container>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import icons from '@/mixins/icons'

  export default {
    name: 'drawer',
    mixins: [icons],
    data() {
      return {
        counter: 0,
        lastClick: Date.now()
      }
    },
    computed: {
      showAccountInfo() {
        return this.$store.state.v4.mode.show
      },

      rtl() {
        return this.$store.state.v4.language.rtl
      },
      language() {
        let choices = [{
          title: 'responses.language.en-US.title',
          value: 'en-US',
          click: { action: 'changeLanguage', params: 'en-US' }
        }]
        try {
          choices = this.languages.map(lang => {
            return {
              title: `responses.${lang.name}.title`,
              value: lang.value,
              click: { action: 'changeLanguage', params: lang.value }
            }
          })
        }
        catch (e) {}
        return choices
      },
      navigationItems() {
        return [
          {
            icon: this.icons.mdiHome,
            title: 'app.nav.menu.encounter.new.title',
            action: { action: 'navigate', params: { name: 'Start' } },
            show: true
          },
          {
            icon: this.icons.mdiAccountGroup,
            title: 'app.nav.menu.encounter.resume.title',
            action: { action: 'navigate', params: { name: 'Encounters' } },
            show: this.hasSaved
          },
          {
            icon: this.icons.mdiPencil,
            title: 'app.summary.user.title',
            clickEvent: 'setStartId',
            show: true
          },
          {
            icon: this.icons.mdiCellphoneWireless,
            title: 'app.nav.menu.device.title',
            action: { action: 'navigate', params: { name: 'Device' } },
            show: this.getMode('show') || this.settings('offline')
          }
        ]
      },
      navigationGroups() {
        return [{
            icon: this.icons.mdiAccount,
            title: 'app.nav.menu.account.title',
            items: this.engagements,
            show: this.showAccountInfo
          }, {
            icon: this.icons.mdiTranslate,
            title: 'app.nav.menu.language.title',
            items: this.language,
            active: true,
            show: true
          },
          {
            icon: this.icons.mdiHammerScrewdriver,
            title: 'app.nav.menu.testing.title',
            items: this.modes,
            active: false,
            show: this.getMode('show')
          },
        ]
      },
      modes() {
        let modes = this.mode.map(x => {
          return {
            title: x.name,
            value: x.value,
            select: true,
            click: { action: 'setMode', params: x.name }
          }
        })
        return modes
      },
      engagements() {
        let engagements = this.logins.map(x => {
          return {
            title: x.name,
            value: x.token,
            click: { action: 'login', params: x.token }
          }
        })
        return engagements
      },
      ...mapGetters({
        hasSaved: 'v4/encounters/hasSaved',
        logins: 'v4/session/logins',
        languages: 'v4/language/all',
        mode: 'v4/mode/all',
        getMode: 'v4/mode/get',
        settings: 'v4/settings/get',
      })
    },
    methods: {
      testModeClick() {
        if (Date.now() - this.lastClick > 2000) {
          this.counter = 1
        }
        else {
          this.counter = this.counter + 1
        }
        if (this.counter > 9) {
          this.counter = 0
          this.setMode('show')
        }
        this.lastClick = Date.now()
      },
      clickHandler: function(functionName) {
        this[functionName]()
      },
      async setStartId() {
        await this.$store.dispatch("v4/startId/new");
        const locations = this.$store.getters['v4/location/rootLocations'];
        const hasLocations = locations && locations.length > 0;
        const selectionsComplete = this.$store.getters['v4/location/selectionsComplete'];

        if (hasLocations && !selectionsComplete) {
          this.action({ action: 'navigate', params: { path: '/location' } })
        } else {
          this.action({ action: 'navigate', params: { path: '/preference/summary' } })
        }
      },
      action({ action, params }) {
        try {
          if (action === 'setMode') {
            this[action](params)
          }
          else {
            this.$emit('navToggle')
            this[action](params)
          }
        }
        catch (e) {
          console.log(e)
        }
      },
      ...mapActions({
        login: 'v4/session/login',
        logout: 'v4/session/logout',
        changeLanguage: 'v4/language/set',
        navigate: 'v4/navigate/to',
        setMode: 'v4/mode/set'
      })
    }
  }
</script>

<style>
  .drawerOpen {
    background-color: rgba(75, 145, 172, .15);
  }

  .photo-header {
    align-items: flex-start;
    max-width: 100%;
    min-height: fit-content !important;
    flex: 0 0 auto !important; 
  }

  .drawer-container {
    min-width: 100%;
    max-height: 100%;
  }

  .flex-list {
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
  }

  .logout-section {
    max-height: 100px;
    align-items: flex-end;
    margin-top: auto;
    min-height: fit-content;
  }

  .v-list-item {
    flex: 0;
  }

  .v-navigation-drawer .v-list .v-list-group.v-list-group--active {
    overflow: auto !important;
    height: 100% !important;
  }

  .v-navigation-drawer__content {
    height: 100%;
  }
</style>
